import { useState } from "react";
import { Box, Typography, Paper, Button, Grid } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

// ✅ Reusable Styled Card (same as StepOne)
const OptionCard = styled(Paper)(({ theme, selected }) => ({
  padding: theme.spacing(4),
  borderRadius: "20px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.08)",
  cursor: "pointer",
  textAlign: "center",
  transition: "transform 0.25s ease, box-shadow 0.25s ease",
  minHeight: "160px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.12)",
  },

  ...(selected && {
    border: "2px solid #30B0C7",
  }),
}));

const StepThree = ({ onNext }) => {
  const navigate = useNavigate();

  const options = [
    { label: "Full Career Counselling", icon: "./Counselling/fullIcon.png" },
    {
      label: "Partial Career Counselling",
      icon: "./Counselling/partialIcon.png",
    },
    {
      label: "Guidance for Chosen Career Path",
      icon: "./Counselling/guidanceIcon.png",
    },
  ];

  const [selected, setSelected] = useState("");

  const handleSelect = (item) => {
    setSelected(item);

    // ✅ Auto navigation for Option 3
    if (item === "Guidance for Chosen Career Path") {
      navigate("/AI/dashboard");
    }
  };

  const handleNextClick = () => {
    if (selected) onNext({ counsellingType: selected });
  };

  return (
    <Box>
      <Typography
        sx={{ textAlign: "center", fontFamily: "Aclonica", py: 2 }}
        variant="h4"
        fontWeight={600}
        mb={3}
      >
        Select type of counselling
      </Typography>

      <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
        {options.map(({ label, icon }) => (
          <Grid item xs={12} sm={6} md={4} key={label}>
            <OptionCard
              selected={selected === label}
              onClick={() => handleSelect(label)}
            >
              <img
                src={icon}
                alt={label}
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "contain",
                  marginBottom: "12px",
                }}
              />
              <Typography fontSize="1rem" fontWeight={600}>
                {label}
              </Typography>
            </OptionCard>
          </Grid>
        ))}
      </Grid>

      {/* ✅ Button only needed for first 2 */}
      {selected !== "Guidance for Chosen Career Path" && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            disabled={!selected}
            onClick={handleNextClick}
            sx={{
              mt: 4,
              backgroundColor: "#30B0C7",
              borderRadius: "100px",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#2799AD" },
              width: "200px",
              p: 1,
              fontSize: "20px",
            }}
          >
            Next
          </Button>
        </div>
      )}
    </Box>
  );
};

export default StepThree;
